var _g, _g2, _g3, _g4, _path, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg45Stars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 24,
    viewBox: "0 0 120 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28304_34332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 17.2702L17.1701 20.3902C17.5501 20.6202 18.0201 20.2802 17.9201 19.8502L16.5501 13.9702L21.1101 10.0202C21.4401 9.73022 21.2701 9.18022 20.8201 9.14022L14.8101 8.63022L12.4601 3.09021C12.2901 2.68021 11.7101 2.68021 11.5401 3.09021L9.19006 8.63022L3.18006 9.14022C2.74006 9.18022 2.56006 9.73022 2.90006 10.0202L7.46006 13.9702L6.09006 19.8502C5.99006 20.2802 6.46006 20.6202 6.84006 20.3902L12.0001 17.2702Z",
    fill: "#D2C02A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_28304_34332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 17.2702L41.1701 20.3902C41.5501 20.6202 42.0201 20.2802 41.9201 19.8502L40.5501 13.9702L45.1101 10.0202C45.4401 9.73022 45.2701 9.18022 44.8201 9.14022L38.8101 8.63022L36.4601 3.09021C36.2901 2.68021 35.7101 2.68021 35.5401 3.09021L33.1901 8.63022L27.1801 9.14022C26.7401 9.18022 26.5601 9.73022 26.9001 10.0202L31.4601 13.9702L30.0901 19.8502C29.9901 20.2802 30.4601 20.6202 30.8401 20.3902L36.0001 17.2702Z",
    fill: "#D2C02A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_28304_34332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 17.2702L65.1701 20.3902C65.5501 20.6202 66.0201 20.2802 65.9201 19.8502L64.5501 13.9702L69.1101 10.0202C69.4401 9.73022 69.2701 9.18022 68.8201 9.14022L62.8101 8.63022L60.4601 3.09021C60.2901 2.68021 59.7101 2.68021 59.5401 3.09021L57.1901 8.63022L51.1801 9.14022C50.7401 9.18022 50.5601 9.73022 50.9001 10.0202L55.4601 13.9702L54.0901 19.8502C53.9901 20.2802 54.4601 20.6202 54.8401 20.3902L60.0001 17.2702Z",
    fill: "#D2C02A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_28304_34332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0001 17.2702L89.1701 20.3902C89.5501 20.6202 90.0201 20.2802 89.9201 19.8502L88.5501 13.9702L93.1101 10.0202C93.4401 9.73022 93.2701 9.18022 92.8201 9.14022L86.8101 8.63022L84.4601 3.09021C84.2901 2.68021 83.7101 2.68021 83.5401 3.09021L81.1901 8.63022L75.1801 9.14022C74.7401 9.18022 74.5601 9.73022 74.9001 10.0202L79.4601 13.9702L78.0901 19.8502C77.9901 20.2802 78.4601 20.6202 78.8401 20.3902L84.0001 17.2702Z",
    fill: "#D2C02A"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_28304_34332)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28304_34332",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 2,
    width: 20,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 17.2702L113.17 20.3902C113.55 20.6202 114.02 20.2802 113.92 19.8502L112.55 13.9702L117.11 10.0202C117.44 9.73022 117.27 9.18022 116.82 9.14022L110.81 8.63022L108.46 3.09021C108.29 2.68021 107.71 2.68021 107.54 3.09021L105.19 8.63022L99.1798 9.14022C98.7398 9.18022 98.5598 9.73022 98.8998 10.0202L103.46 13.9702L102.09 19.8502C101.99 20.2802 102.46 20.6202 102.84 20.3902L108 17.2702Z",
    fill: "#001030"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28304_34332)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 19,
    transform: "matrix(-1 0 0 1 108 2)",
    fill: "#D2C02A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28304_34332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28304_34332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_28304_34332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(48)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_28304_34332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(72)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_28304_34332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(96)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45Stars);
export default __webpack_public_path__ + "static/media/4-5-stars.df4bcc5e2aaa9b4a67d969dc72afdba9.svg";
export { ForwardRef as ReactComponent };